import React, { useEffect, useRef, useState } from "react";
import localeText from "../../../../locale";
import BannerCarousel from "../../../Shop/components/BannerCarousel/BannerCarousel";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import "./styles.css";
import BannerUpload from "./BannerUpload";
import { locale } from "../../../../utilities/locale/locale";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import ProductService from "../../../../service/ProductService";
import MarketplaceService from "../../../../service/Makertplace";
import Loading from "../../../../components/Loading/Loading";
import { Checkbox } from "primereact/checkbox";
import BestDeals from "../../../Shop/components/BestDeals/BestDeals";
import Cropper from "react-cropper";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";

const MAIN_BANNER_RATIO = 3 / 1;
const SUB_BANNER_RATIO = 7 / 4;

const PrincipalBanners = ({ title, type }) => {
  const [isLoadingBanners, setIsLoadingBanners] = useState(true);
  const [isLoadingUpload, setIsLoadingUpload] = useState(false);

  const [imageDesktopEnglish, setImageDesktopEnglish] = useState(null);
  const [imageDesktopItalian, setImageDesktopItalian] = useState(null);
  const [imageDesktopPortuguese, setImageDesktopPortuguese] = useState(null);
  const [imageDesktopSpanish, setImageDesktopSpanish] = useState(null);
  const [imageMobileEnglish, setImageMobileEnglish] = useState(null);
  const [imageMobileItalian, setImageMobileItalian] = useState(null);
  const [imageMobilePortuguese, setImageMobilePortuguese] = useState(null);
  const [imageMobileSpanish, setImageMobileSpanish] = useState(null);

  const [delayMainSlider, setDelayMainSlider] = useState(1);
  const [delaySubSlider, setDelaySubSlider] = useState(1);

  const [urlToRedirect, setUrlToRedirect] = useState("");

  const [mainBanners, setMainBanners] = useState([]);

  const [deleteBannerIds, setDeleteBannerIds] = useState([]);

  const [showBanner, setShowBanner] = useState(false);

  const [language, setLanguage] = useState(locale);
  const [languageMobile, setLanguageMobile] = useState(locale);

  const [isOpenCropModal, setIsOpenCropModal] = useState(false);

  const [actualImg, setActualImg] = useState();

  const [imagesBanners, setImagesBanners] = useState([
    {
      title: "imageDesktopEnglish",
      setImages: setImageDesktopEnglish,
      isChecked: false,
    },
    {
      title: "imageDesktopItalian",
      setImages: setImageDesktopItalian,
      isChecked: false,
    },
    {
      title: "imageDesktopPortuguese",
      setImages: setImageDesktopPortuguese,
      isChecked: false,
    },
    {
      title: "imageDesktopSpanish",
      setImages: setImageDesktopSpanish,
      isChecked: false,
    },
    { title: "imageMobileEnglish", setImages: setImageMobileEnglish, isChecked: false },
    { title: "imageMobileItalian", setImages: setImageMobileItalian, isChecked: false },
    {
      title: "imageMobilePortuguese",
      setImages: setImageMobilePortuguese,
      isChecked: false,
    },
    { title: "imageMobileSpanish", setImages: setImageMobileSpanish, isChecked: false },
  ]);

  const [modalLangImages, setModalLangImages] = useState([
    {
      title: "imageDesktopEnglish",
      setImages: () => {},
      isChecked: false,
    },
    {
      title: "imageDesktopItalian",
      setImages: () => {},
      isChecked: false,
    },
    {
      title: "imageDesktopPortuguese",
      setImages: () => {},
      isChecked: false,
    },
    {
      title: "imageDesktopSpanish",
      setImages: () => {},
      isChecked: false,
    },
    { title: "imageMobileEnglish", setImages: () => {}, isChecked: false },
    { title: "imageMobileItalian", setImages: () => {}, isChecked: false },
    {
      title: "imageMobilePortuguese",
      setImages: () => {},
      isChecked: false,
    },
    { title: "imageMobileSpanish", setImages: () => {}, isChecked: false },
  ]);

  const cropperRef = useRef(null);

  const { showErrorToast, showSuccessToast } = useToastContext();

  const productService = new ProductService();
  const marketplaceService = new MarketplaceService();

  const bannersLang = {
    en: imageDesktopEnglish,
    it: imageDesktopItalian,
    pt: imageDesktopPortuguese,
    es: imageDesktopSpanish,
  };

  const bannersMobileLang = {
    en: imageMobileEnglish,
    it: imageMobileItalian,
    pt: imageMobilePortuguese,
    es: imageMobileSpanish,
  };

  const bannersUploadComponets = [
    {
      images: imageDesktopEnglish,
      setImages: setImageDesktopEnglish,
      title: "imageDesktopEnglish",
    },
    {
      images: imageDesktopItalian,
      setImages: setImageDesktopItalian,
      title: "imageDesktopItalian",
    },
    {
      images: imageDesktopPortuguese,
      setImages: setImageDesktopPortuguese,
      title: "imageDesktopPortuguese",
    },
    {
      images: imageDesktopSpanish,
      setImages: setImageDesktopSpanish,
      title: "imageDesktopSpanish",
    },
    { images: imageMobileEnglish, setImages: setImageMobileEnglish, title: "imageMobileEnglish" },
    { images: imageMobileItalian, setImages: setImageMobileItalian, title: "imageMobileItalian" },
    {
      images: imageMobilePortuguese,
      setImages: setImageMobilePortuguese,
      title: "imageMobilePortuguese",
    },
    { images: imageMobileSpanish, setImages: setImageMobileSpanish, title: "imageMobileSpanish" },
  ];

  const languages = [
    { id: "english", value: "en", label: "english" },
    { id: "italian", value: "it", label: "italian" },
    { id: "portuguese", value: "pt", label: "portuguese" },
    { id: "spanish", value: "es", label: "spanish" },
  ];

  const previewImage = (files) => {
    let allFiles = [files, ...mainBanners];

    const fileLangs = {
      en: "imageDesktopEnglish",
      it: "imageDesktopItalian",
      pt: "imageDesktopPortuguese",
      es: "imageDesktopSpanish",
    };

    const previewFiles = allFiles.map((file, index) => {
      if (file[fileLangs[language]] && typeof file[fileLangs[language]] === "string") {
        return { id: index, bgImg: file[fileLangs[language]], cloudinary: true };
      }

      if (
        file[fileLangs[language]] &&
        Array.isArray(file[fileLangs[language]]) &&
        file[fileLangs[language]].length > 0
      ) {
        return {
          id: index,
          bgImg: URL.createObjectURL(file[fileLangs[language]][0]),
        };
      }

      if (typeof file === "string") return { id: index, bgImg: file, cloudinary: true };

      if (!Array.isArray(file) || file.length === 0) return [];

      if (!file) return [];

      return { id: index, bgImg: URL.createObjectURL(files[0]) };
    });

    return previewFiles;
  };

  const handleImagesUpload = async () => {
    try {
      setIsLoadingUpload(true);

      if (
        !imageDesktopEnglish &&
        !imageDesktopItalian &&
        !imageDesktopPortuguese &&
        !imageDesktopSpanish &&
        !imageMobileEnglish &&
        !imageMobileItalian &&
        !imageMobilePortuguese &&
        !imageMobileSpanish
      ) {
        showErrorToast({ detail: "noImageSelected" });
        return;
      }

      let imgPTDesktop = null;
      let imgITDesktop = null;
      let imgESDesktop = null;
      let imgENDesktop = null;
      let imgPTMobile = null;
      let imgITMobile = null;
      let imgESMobile = null;
      let imgENMobile = null;

      const imagesToUpload = [
        { image: imageDesktopEnglish, setter: (url) => (imgENDesktop = url) },
        { image: imageDesktopItalian, setter: (url) => (imgITDesktop = url) },
        { image: imageDesktopPortuguese, setter: (url) => (imgPTDesktop = url) },
        { image: imageDesktopSpanish, setter: (url) => (imgESDesktop = url) },
        { image: imageMobileEnglish, setter: (url) => (imgENMobile = url) },
        { image: imageMobileItalian, setter: (url) => (imgITMobile = url) },
        { image: imageMobilePortuguese, setter: (url) => (imgPTMobile = url) },
        { image: imageMobileSpanish, setter: (url) => (imgESMobile = url) },
      ];

      for (const { image, setter } of imagesToUpload) {
        if (image && typeof image !== "string") {
          const uploadedUrl = await handleImageUpload(image);
          setter(uploadedUrl);
        } else {
          setter(image);
        }
      }

      let mainBannersValues = [];

      if (mainBanners.length > 0) {
        for (let i = 0; i < mainBanners.length; i++) {
          const banner = mainBanners[i];
          const bannerImagesToUpload = [
            {
              image: banner.imageDesktopEnglish,
              setter: (url) => (banner.imageDesktopEnglish = url),
            },
            {
              image: banner.imageDesktopItalian,
              setter: (url) => (banner.imageDesktopItalian = url),
            },
            {
              image: banner.imageDesktopPortuguese,
              setter: (url) => (banner.imageDesktopPortuguese = url),
            },
            {
              image: banner.imageDesktopSpanish,
              setter: (url) => (banner.imageDesktopSpanish = url),
            },
            {
              image: banner.imageMobileEnglish,
              setter: (url) => (banner.imageMobileEnglish = url),
            },
            {
              image: banner.imageMobileItalian,
              setter: (url) => (banner.imageMobileItalian = url),
            },
            {
              image: banner.imageMobilePortuguese,
              setter: (url) => (banner.imageMobilePortuguese = url),
            },
            {
              image: banner.imageMobileSpanish,
              setter: (url) => (banner.imageMobileSpanish = url),
            },
          ];
          for (const { image, setter } of bannerImagesToUpload) {
            if (image && typeof image !== "string") {
              const uploadedUrl = await handleImageUpload(image);
              setter(uploadedUrl);
            } else {
              setter(image);
            }
          }
          mainBanners[i] = banner;
        }
        setMainBanners(mainBanners);
        mainBannersValues = mainBanners;
      }

      try {
        await marketplaceService.postDelayBanners({
          delayMainBanner: delayMainSlider,
          delaySubBanners: delaySubSlider,
        });
      } catch (error) {
        console.log(error);
      }

      const data = {
        imageDesktopEnglish: imgENDesktop,
        imageDesktopItalian: imgITDesktop,
        imageDesktopPortuguese: imgPTDesktop,
        imageDesktopSpanish: imgESDesktop,
        imageMobileEnglish: imgENMobile,
        imageMobileItalian: imgITMobile,
        imageMobilePortuguese: imgPTMobile,
        imageMobileSpanish: imgESMobile,
        showImage: showBanner,
        urlDestination: urlToRedirect,
      };

      try {
        if (deleteBannerIds.length > 0) {
          for (let i = 0; i < deleteBannerIds.length; i++) {
            const bannerId = deleteBannerIds[i];
            await marketplaceService.deleteMainBanner(bannerId);
          }
          setDeleteBannerIds([]);
        }

        await marketplaceService.postUploadBannner(data, type);

        if (mainBannersValues.length > 0) {
          for (let i = 0; i < mainBannersValues.length; i++) {
            const bannerData = mainBannersValues[i];

            await marketplaceService.postUploadNewMainBanner(bannerData);
          }
        }

        showSuccessToast({ detail: "settingsSaved" });

        await getBanners();
      } catch (e) {
        if (e.status === 500) showErrorToast({ detail: "unexpectedSystemBehaviour" });
        else showErrorToast({ detail: "unexpectedErrorUploadImg" });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoadingUpload(false);
    }
  };

  const handleImageUpload = async (image) => {
    try {
      const res = await productService.postUploadImage(
        localStorage.getItem("__extraconomy_token"),
        image[0],
      );

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });
      }

      return res.result;
    } catch (e) {
      if (e.status === 500) showErrorToast({ detail: "unexpectedSystemBehaviour" });
      else showErrorToast({ detail: "unexpectedErrorUploadImg" });
    }
  };

  const getBanners = async () => {
    try {
      const resBannners = await marketplaceService.getConfiguration();

      let bannersConfig;

      bannersConfig = resBannners?.result?.mainBanner;

      setDelayMainSlider(resBannners?.result?.delayMainBanner);
      setDelaySubSlider(resBannners?.result?.delaySubBanners);

      const imageSetters = [
        { value: bannersConfig?.imageDesktopEnglish, setter: setImageDesktopEnglish },
        { value: bannersConfig?.imageDesktopItalian, setter: setImageDesktopItalian },
        { value: bannersConfig?.imageDesktopPortuguese, setter: setImageDesktopPortuguese },
        { value: bannersConfig?.imageDesktopSpanish, setter: setImageDesktopSpanish },
        { value: bannersConfig?.imageMobileEnglish, setter: setImageMobileEnglish },
        { value: bannersConfig?.imageMobileItalian, setter: setImageMobileItalian },
        { value: bannersConfig?.imageMobilePortuguese, setter: setImageMobilePortuguese },
        { value: bannersConfig?.imageMobileSpanish, setter: setImageMobileSpanish },
        { value: bannersConfig?.showImage, setter: setShowBanner },
      ];

      imageSetters.forEach(({ value, setter }) => {
        if (value) setter(value);
      });

      setUrlToRedirect(bannersConfig?.urlDestination);

      let mainBannersConfig = [];

      mainBannersConfig = resBannners?.result?.mainBanners;

      if (mainBannersConfig && mainBannersConfig.length > 0) setMainBanners(mainBannersConfig);
      else setMainBanners([]);
    } catch (e) {
      showErrorToast({ code: 500000 });
      console.error(e);
    }
  };

  const initalgetBanners = async () => {
    try {
      setIsLoadingBanners(true);
      await getBanners();
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoadingBanners(false);
    }
  };

  const onSetImage = (img, setImg, title, type = "", index) => {
    const files = Array.from(img);
    const reader = new FileReader();

    reader.onload = () => {
      setActualImg({ img: reader.result, setImg: setImg, title: title, type: type, index: index });
      setIsOpenCropModal(true);
    };

    reader.readAsDataURL(files[0]);
  };

  const dataURLtoFile = (dataurl, filename) => {
    let arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const getCroppedImage = () => {
    if (cropperRef.current) {
      const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas();
      const croppedImageBase64 = croppedCanvas.toDataURL();
      const croppedImageFile = dataURLtoFile(croppedImageBase64, "croppedImage.png");

      actualImg.setImg([croppedImageFile]);

      if (actualImg.type === "first") {
        imagesBanners.forEach((img) => {
          if (img.isChecked) img.setImages([croppedImageFile]);
        });
      } else {
        setMainBanners((prev) =>
          prev.map((banner, i) => {
            if (i !== actualImg.index) return banner;

            const updated = { ...banner };
            modalLangImages.forEach((img) => {
              if (img.isChecked) {
                updated[img.title] = [croppedImageFile];
              }
            });

            return updated;
          }),
        );
      }

      setIsOpenCropModal(false);
    }
  };

  const addNewBanner = () => {
    const newBanner = {
      imageDesktopEnglish: null,
      imageDesktopItalian: null,
      imageDesktopPortuguese: null,
      imageDesktopSpanish: null,
      imageMobileEnglish: null,
      imageMobileItalian: null,
      imageMobilePortuguese: null,
      imageMobileSpanish: null,
      showImage: true,
      urlDestination: "",
    };

    setMainBanners((prev) => [...prev, newBanner]);
  };

  const mainBannersUploadComponets = (banner, index) => {
    return [
      {
        images: banner.imageDesktopEnglish,
        setImages: (img) => {
          const updatedBanners = [...mainBanners];
          updatedBanners[index].imageDesktopEnglish = img;
          setMainBanners(updatedBanners);
        },
        title: "imageDesktopEnglish",
      },
      {
        images: banner.imageDesktopItalian,
        setImages: (img) => {
          const updatedBanners = [...mainBanners];
          updatedBanners[index].imageDesktopItalian = img;
          setMainBanners(updatedBanners);
        },
        title: "imageDesktopItalian",
      },
      {
        images: banner.imageDesktopPortuguese,
        setImages: (img) => {
          const updatedBanners = [...mainBanners];
          updatedBanners[index].imageDesktopPortuguese = img;
          setMainBanners(updatedBanners);
        },
        title: "imageDesktopPortuguese",
      },
      {
        images: banner.imageDesktopSpanish,
        setImages: (img) => {
          const updatedBanners = [...mainBanners];
          updatedBanners[index].imageDesktopSpanish = img;
          setMainBanners(updatedBanners);
        },
        title: "imageDesktopSpanish",
      },
      {
        images: banner.imageMobileEnglish,
        setImages: (img) => {
          const updatedBanners = [...mainBanners];
          updatedBanners[index].imageMobileEnglish = img;
          setMainBanners(updatedBanners);
        },
        title: "imageMobileEnglish",
      },
      {
        images: banner.imageMobileItalian,
        setImages: (img) => {
          const updatedBanners = [...mainBanners];
          updatedBanners[index].imageMobileItalian = img;
          setMainBanners(updatedBanners);
        },
        title: "imageMobileItalian",
      },
      {
        images: banner.imageMobilePortuguese,
        setImages: (img) => {
          const updatedBanners = [...mainBanners];
          updatedBanners[index].imageMobilePortuguese = img;
          setMainBanners(updatedBanners);
        },
        title: "imageMobilePortuguese",
      },
      {
        images: banner.imageMobileSpanish,
        setImages: (img) => {
          const updatedBanners = [...mainBanners];
          updatedBanners[index].imageMobileSpanish = img;
          setMainBanners(updatedBanners);
        },
        title: "imageMobileSpanish",
      },
    ];
  };

  const removeBanner = (banner, index) => {
    if (banner?.id) setDeleteBannerIds((prev) => [...prev, banner.id]);

    const updatedBanners = [...mainBanners];

    updatedBanners.splice(index, 1);

    setMainBanners(updatedBanners);
  };

  useEffect(() => {
    initalgetBanners(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const canRenderDesktopPreview =
    bannersLang[language] &&
    Array.isArray(previewImage(bannersLang[language])) &&
    previewImage(bannersLang[language]).length > 0;

  const canRenderMobilePreview =
    bannersMobileLang[languageMobile] &&
    Array.isArray(previewImage(bannersMobileLang[languageMobile])) &&
    previewImage(bannersMobileLang[languageMobile]).length > 0;

  return (
    <div className="card">
      <h3 className="my-3">{title} Upload</h3>

      {isLoadingBanners ? (
        <Loading classNameIcon={"text-4xl"} />
      ) : (
        <>
          {isOpenCropModal && (
            <Dialog
              header={`${localeText("keepImageInRequiredAspectRatio")} ${
                type === "main" ? ` (3 / 1)` : ` (7 / 4)`
              } - (${localeText(actualImg?.title)})`}
              visible={isOpenCropModal}
              onHide={() => {
                setIsOpenCropModal(false);
              }}
              breakpoints={{ "960px": "85vw" }}
              style={{ width: "50vw" }}
              draggable={false}
            >
              <Cropper
                ref={cropperRef}
                src={actualImg?.img}
                style={{ height: 400, width: "100%", marginBottom: 10 }}
                aspectRatio={type === "main" ? MAIN_BANNER_RATIO : SUB_BANNER_RATIO}
              />
              {actualImg.type === "first" ? (
                <div className="mb-4">
                  <p>{localeText("doYouWantToRepeatThisImage")}</p>

                  <div className="flex gap-2 justify-content-start flex-wrap">
                    {imagesBanners.map((banner, index) => {
                      if (banner.title === actualImg.title) return null;
                      return (
                        <div className="flex align-items-center" key={index}>
                          <Checkbox
                            inputId={`${banner.title}`}
                            onChange={() => {
                              setImagesBanners((prev) =>
                                prev.map((img) =>
                                  img.title === banner.title
                                    ? { ...img, isChecked: !img.isChecked }
                                    : img,
                                ),
                              );
                            }}
                            checked={
                              imagesBanners.find((img) => img.title === banner.title).isChecked ===
                              true
                            }
                          />

                          <label htmlFor={`${banner.title}`} className="ml-2">
                            <strong>{localeText(banner.title)}</strong>
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div className="mb-4">
                  <p>{localeText("doYouWantToRepeatThisImage")}</p>

                  <div className="flex gap-2 justify-content-start flex-wrap">
                    {modalLangImages.map((banner, index) => {
                      if (banner.title === actualImg.title) return null;

                      return (
                        <div className="flex align-items-center" key={index}>
                          <Checkbox
                            inputId={`${banner.title}`}
                            onChange={() => {
                              setModalLangImages((prev) =>
                                prev.map((img) =>
                                  img.title === banner.title
                                    ? { ...img, isChecked: !img.isChecked }
                                    : img,
                                ),
                              );
                            }}
                            checked={
                              modalLangImages.find((img) => img.title === banner.title)
                                ?.isChecked === true
                            }
                          />

                          <label htmlFor={`${banner.title}`} className="ml-2">
                            <strong>{localeText(banner.title)}</strong>
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              <div className="flex justify-content-end">
                <Button
                  onClick={getCroppedImage}
                  style={{
                    background: "#272360",
                  }}
                >
                  {localeText("cropImage")}
                </Button>
              </div>
            </Dialog>
          )}

          <div>
            <div className="mb-4">
              <h5>{localeText("generalSettings")}</h5>

              <div className="flex flex-column gap-2 mt-4">
                <label htmlFor="delay" className="text-base">
                  {localeText("sliderChangeTime")}
                </label>

                <div className="flex align-items-center gap-2 w-full">
                  <InputNumber
                    value={delayMainSlider}
                    onValueChange={(e) => setDelayMainSlider(e.value)}
                    id="delay"
                    min={1}
                  />

                  <p>{localeText("seconds")}</p>
                </div>
              </div>
            </div>

            <div>
              <h5>Banner 1</h5>

              <div className="bannersContainer">
                {bannersUploadComponets.map(({ images, setImages, title }, index) => (
                  <BannerUpload
                    key={index}
                    images={images}
                    setImages={(img) => onSetImage(img, setImages, title, "first")}
                    title={title}
                  />
                ))}
              </div>

              <div className="flex flex-column gap-2 mt-4">
                <label htmlFor="url" className="text-lg">
                  {localeText("urlToRedirect")}
                </label>

                <InputText
                  id="url"
                  value={urlToRedirect}
                  onChange={(e) => setUrlToRedirect(e.target.value)}
                  placeholder={"Url"}
                  className="col p-3"
                />
              </div>

              <div className="flex align-items-center mt-4">
                <Checkbox
                  inputId="showBanner"
                  onChange={() => {
                    setShowBanner((prev) => !prev);
                  }}
                  checked={showBanner === true}
                />
                <label htmlFor="showBanner" className="ml-2">
                  {localeText("showBanner")}
                </label>
              </div>
            </div>

            {mainBanners.length > 0 &&
              mainBanners.map((banner, index) => (
                <div className="mt-4" key={index}>
                  <div className="flex align-items-center justify-content-between">
                    <h5 className="mb-0">Banner {index + 2}</h5>

                    <Button
                      size="large"
                      label={`${localeText("removeBanner")} ${index + 2}`}
                      onClick={() => removeBanner(banner, index)}
                      icon="pi pi-times"
                      className="p-button-danger p-button-outlined"
                    />
                  </div>

                  <div className="bannersContainer">
                    {mainBannersUploadComponets(banner, index).map(
                      ({ images, setImages, title }) => (
                        <BannerUpload
                          key={title}
                          images={images}
                          setImages={(img) => onSetImage(img, setImages, title, "", index)}
                          title={title}
                        />
                      ),
                    )}
                  </div>

                  <div className="flex flex-column gap-2 mt-4">
                    <label htmlFor="url" className="text-lg">
                      {localeText("urlToRedirect")}
                    </label>

                    <InputText
                      id="url"
                      value={banner.urlDestination}
                      onChange={(e) => {
                        const updatedBanners = [...mainBanners];

                        updatedBanners[index].urlDestination = e.target.value;

                        setMainBanners(updatedBanners);
                      }}
                      placeholder={"Url"}
                      className="col p-3"
                    />
                  </div>

                  <div className="flex align-items-center mt-4">
                    <Checkbox
                      inputId={`showBanner${index + 2}`}
                      onChange={() => {
                        const updatedBanners = [...mainBanners];
                        updatedBanners[index].showImage = !updatedBanners[index].showImage;
                        setMainBanners(updatedBanners);
                      }}
                      checked={banner.showImage === true}
                    />
                    <label htmlFor={`showBanner${index + 2}`} className="ml-2">
                      {localeText("showBanner")}
                    </label>
                  </div>
                </div>
              ))}

            <div className="mt-4">
              <Button
                size="large"
                label={localeText("addNewBanner")}
                onClick={addNewBanner}
                icon="pi pi-plus"
                style={{
                  background: "#272360",
                }}
              />
            </div>

            <div className="flex justify-content-end mt-4">
              <Button
                size="large"
                label={localeText("save")}
                onClick={handleImagesUpload}
                loading={isLoadingUpload}
                style={{
                  background: "#272360",
                }}
              />
            </div>

            <div className="content-grid bg-white">
              <div className="mt-4">
                <h5>Preview Desktop</h5>

                <div className="flex gap-2 xl:flex-row flex-column mb-4">
                  <label>{localeText("language")}:</label>

                  {languages.map(({ id, value, label }) => (
                    <div key={id}>
                      <RadioButton
                        inputId={`${id}`}
                        value={value}
                        onChange={(e) => setLanguage(e.value)}
                        checked={language === value}
                      />
                      <label htmlFor={`${id}`} className="pl-2 cursor-pointer">
                        {localeText(label)}
                      </label>
                    </div>
                  ))}
                </div>

                {canRenderDesktopPreview ? (
                  <>
                    <div className="w-full">
                      <BannerCarousel items={previewImage(bannersLang[language])} />
                    </div>
                    <BestDeals />
                  </>
                ) : (
                  <p>{localeText("dontHaveImage")}</p>
                )}
              </div>

              <div className="mt-4">
                <h5>Preview Mobile - 350px</h5>

                <div className="flex gap-2 xl:flex-row flex-column mb-4">
                  {languages.map(({ id, value, label }) => (
                    <div key={id}>
                      <RadioButton
                        inputId={`${id}-mobile`}
                        value={value}
                        onChange={(e) => setLanguageMobile(e.value)}
                        checked={languageMobile === value}
                      />
                      <label htmlFor={`${id}-mobile`} className="pl-2 cursor-pointer">
                        {localeText(label)}
                      </label>
                    </div>
                  ))}
                </div>

                <div style={{ maxWidth: "350px" }}>
                  {canRenderMobilePreview ? (
                    <>
                      <div>
                        <BannerCarousel items={previewImage(bannersMobileLang[languageMobile])} />
                      </div>
                      <BestDeals />
                    </>
                  ) : (
                    <p>{localeText("dontHaveImage")}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PrincipalBanners;
